// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"de585573","55":"d8cf6c6d","152":"4abb5ad8","171":"a7b9ce7e","315":"29e2036d","362":"9652fa5c","453":"665c8137","466":"ab7cf428","521":"11a64e66","599":"9769ff42","743":"a06e1a1a","780":"b668a761","968":"cfd20b7a"}[chunkId] + ".chunk.js";
};